import React, { createContext, useContext, useState, useCallback } from 'react'

const LikeContext = createContext()

export const useLike = () => {
  const context = useContext(LikeContext)
  if (!context) {
    throw new Error('useLike must be used within a LikeProvider')
  }
  return context
}

export const LikeProvider = ({ children }) => {
  // 좋아요 상태 관리 (퀴즈 ID를 키로 하는 객체)
  const [likeStates, setLikeStates] = useState({})

  // 좋아요 상태 초기화 (좋아요한 퀴즈 목록을 받아서 설정)
  const initializeLikeStates = useCallback((likedQuizzes) => {
    console.log('💜 [LikeContext] initializeLikeStates 호출됨, 입력:', likedQuizzes)
    const likedStatesObj = {}
    likedQuizzes.forEach(quiz => {
      console.log('💜 [LikeContext] 퀴즈 ID 추가:', quiz.id, '타입:', typeof quiz.id)
      likedStatesObj[quiz.id] = true
    })
    console.log('💜 [LikeContext] 생성된 likedStatesObj:', likedStatesObj)
    setLikeStates(prevStates => {
      const newState = { ...prevStates, ...likedStatesObj }
      console.log('💜 [LikeContext] 새로운 likeStates:', newState)
      return newState
    })
  }, [])

  // 좋아요 상태 업데이트
  const updateLikeState = useCallback((quizId, isLiked) => {
    setLikeStates(prev => ({
      ...prev,
      [quizId]: isLiked
    }))
  }, [])

  // 좋아요 토글 API 호출
  const toggleLike = useCallback(async (quizId) => {
    try {
      console.log('❤️ 전역 좋아요 토글 요청:', quizId)

      const response = await fetch('/auth/toggle-quiz-like', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        credentials: 'include',
        body: JSON.stringify({
          quizId: quizId
        })
      })

      const data = await response.json()
      console.log('❤️ 전역 좋아요 토글 응답:', data)

      if (data.success) {
        const isNowLiked = data.action === 'liked'

        // 전역 좋아요 상태 업데이트
        updateLikeState(quizId, isNowLiked)

        return {
          success: true,
          isLiked: isNowLiked,
          action: data.action
        }
      } else {
        console.error('❌ 좋아요 토글 실패:', data.error)
        return {
          success: false,
          error: data.error || '좋아요 처리 중 오류가 발생했습니다.'
        }
      }
    } catch (error) {
      console.error('❌ 좋아요 토글 오류:', error)
      return {
        success: false,
        error: '좋아요 처리 중 오류가 발생했습니다.'
      }
    }
  }, [updateLikeState])

  // 좋아요 상태 확인
  const isLiked = useCallback((quizId) => {
    const result = likeStates[quizId] || false
    console.log('💜 [LikeContext] isLiked 호출 - quizId:', quizId, '타입:', typeof quizId, '현재 likeStates:', likeStates, '결과:', result)
    return result
  }, [likeStates])

  const value = {
    likeStates,
    initializeLikeStates,
    updateLikeState,
    toggleLike,
    isLiked
  }

  return (
    <LikeContext.Provider value={value}>
      {children}
    </LikeContext.Provider>
  )
}